import { Link } from "react-router-dom";
import { useState } from "react";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";

import QLOLogoMark from "../assets/QLOLogoMark.png";
import { ReactComponent as PhoneIcon } from "../assets/phone.svg";
import { ReactComponent as MailIcon } from "../assets/mail.svg";

import {
    EMAIL_ADD,
    LOCATION_ADD,
    PHONE,
    PHONE_NUMBER,
} from "./constants";

const links = [
    { name: "Home", href: "/" },
    { name: "About us", href: "/about/" },
    { name: "Practices", href: "/practices/" },
    { name: "Careers", href: "/careers/" },
    { name: "Feedback", href: "/feedback/" },
    { name: "Contact us", href: "/contact/" },
];

export default function Footer() {
    const [hovered, setHovered] = useState("");

    return (
        <footer className="relative mt-20 overflow-hidden border-t border-zinc-700 bg-gradient-to-b from-[#181818] via-[#101010] to-black">

            {/* Metallic Shine */}
            <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(120deg,transparent_20%,rgba(255,255,255,.04)_45%,transparent_80%)]" />

            {/* Top Glow */}
            <div className="pointer-events-none absolute top-0 left-0 h-24 w-full bg-gradient-to-b from-white/5 to-transparent" />

            <div className="relative z-10 mx-auto max-w-7xl px-6 py-16">

                <div className="grid items-start gap-24 lg:grid-cols-[1.2fr_0.8fr]">

                    {/* LEFT */}

                    <div className="flex flex-col text-center lg:text-left">

                        <img
                            src={QLOLogoMark}
                            alt="QLO Logo"
                            className="mx-auto w-72 lg:mx-0"
                        />

                        <div className="my-6 h-px w-24 bg-gradient-to-r from-transparent via-zinc-400 to-transparent lg:from-zinc-400 lg:to-transparent" />

                        <p className="max-w-md leading-9 text-zinc-400 mx-auto lg:mx-0">
                            An independent, full-service law firm in Cebu City,
                            Philippines, delivering competent, ethical, and
                            professional legal services. With years of
                            experience, we continue to expand our presence
                            locally and internationally.
                        </p>

                        <div className="mt-10 flex justify-center gap-4 lg:justify-start">

                            <a
                                href="https://facebook.com/quilatonlawoffice"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group flex h-12 w-12 items-center justify-center rounded-full border border-white/20 bg-black/20 backdrop-blur-md transition-all duration-300 hover:border-white/70 hover:bg-white/10 hover:scale-105"
                            >
                                <FaFacebookF className="text-white transition group-hover:scale-110" />
                            </a>

                            <a
                                href="https://linkedin.com/in/atty-abelardo-quilaton-jr-5a3b25248/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group flex h-12 w-12 items-center justify-center rounded-full border border-white/20 bg-black/20 backdrop-blur-md transition-all duration-300 hover:border-white/70 hover:bg-white/10 hover:scale-105"
                            >
                                <FaLinkedinIn className="text-white transition group-hover:scale-110" />
                            </a>

                        </div>

                    </div>

                    {/* RIGHT */}

                    <div className="flex flex-col text-center lg:text-left">

                        <h2 className="font-fontMontserrat text-2xl tracking-[0.3em] text-white">
                            CONTACT
                        </h2>

                        <div className="my-6 h-px w-20 bg-gradient-to-r from-transparent via-zinc-400 to-transparent lg:from-zinc-400 lg:to-transparent" />

                        <div className="space-y-7 text-zinc-400">

                            <p className="leading-8">
                                {LOCATION_ADD}
                            </p>

                            <a
                                href={`tel:${PHONE}`}
                                className="flex items-center justify-center gap-4 transition duration-300 hover:text-white lg:justify-start"
                            >
                                <PhoneIcon className="h-5 w-5 shrink-0" />
                                <span>{PHONE_NUMBER}</span>
                            </a>

                            <a
                                href={`mailto:${EMAIL_ADD}`}
                                className="flex items-center justify-center gap-4 transition duration-300 hover:text-white lg:justify-start"
                            >
                                <MailIcon className="h-5 w-5 shrink-0" />
                                <span>{EMAIL_ADD}</span>
                            </a>

                        </div>

                    </div>

                </div>

            </div>

            {/* Bottom */}

            <div className="relative z-10 border-t border-zinc-800">

                <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-6 py-6 lg:flex-row">

                    <small className="text-center text-zinc-500 lg:text-left">
                        © {new Date().getFullYear()} Quilaton Law Office. All Rights Reserved.
                    </small>

                    <div className="flex flex-wrap justify-center gap-7">

                        {links.map((link) => (
                            <Link
                                key={link.name}
                                to={link.href}
                                onMouseEnter={() => setHovered(link.name)}
                                onMouseLeave={() => setHovered("")}
                                className="relative text-sm text-zinc-500 transition-colors duration-300 hover:text-white"
                            >
                                {link.name}

                                <span
                                    className={`absolute -bottom-1 left-0 h-px bg-gradient-to-r from-zinc-300 to-white transition-all duration-300 ${
                                        hovered === link.name
                                            ? "w-full"
                                            : "w-0"
                                    }`}
                                />
                            </Link>
                        ))}

                    </div>

                </div>

            </div>

        </footer>
    );
}